const defaultTranslations = [{ locale: 'en', content: '' }];

export default defaultTranslations;
